export const CLASS_ASIDE_PANEL_ACTIONS_SECTION_TITLE = 'aside-panel__actions-section-title';
export const CLASS_ASIDE_PANEL_ACTIONS_SECTION_TITLE_SECOND = 'aside-panel__actions-section-title-second';
export const CLASS_ASIDE_PANEL_ACTIONS_SECTION_ADD_PROPERTIES = 'aside-panel__actions-section-add-properties';
export const CLASS_ASIDE_PANEL_ACTIONS_SECTION_ACTIONS = 'aside-panel__actions-section-actions';
export const CLASS_ASIDE_PANEL_ACTIONS_SECTION_CONTAINER = 'aside-panel__actions-section-container';
